module.exports = __webpack_public_path__ + "img/bg_final.6831d428.png";